import { useParams } from 'react-router-dom';
import { useContext, useMemo } from 'react';
import type { AllEntities, BaseEntity } from 'c-sdk';
import { useEntityData } from 'c-data';
import { UseEntityPageContext } from 'c-wrapper/Components/PostAuth/Context';
import type { PageEntityConfig } from 'c-config';

function useEntityPage<Entity extends BaseEntity = BaseEntity>() {
    const { id } = useParams<{ id: string }>();
    const { entityName, pageConfig } = useContext(UseEntityPageContext);
    // GetEntityPage always provides the name; the context default (undefined) only applies outside
    // an entity page, where this hook isn't used
    const { getById } = useEntityData<Entity>(entityName as keyof AllEntities);

    return useMemo(
        () => ({
            id: +id,
            entity: getById({ id: id as any }),
            pageConfig: pageConfig as PageEntityConfig<Entity> | null,
        }),
        [id, getById, pageConfig],
    );
}

export default useEntityPage;
